import { useEffect, useRef } from "react";

import { styled } from "../../../styles";

/** The row / header checkbox of a multi-select admin table. */
export const SelectCell = styled("input", {
  width: "16px",
  height: "16px",
  cursor: "pointer",
  accentColor: "$primary",

  "&:disabled": {
    cursor: "not-allowed",
  },
});

/** "3 selected" beside a table's bulk actions. */
export const SelectionCount = styled("span", {
  fontSize: "13px",
  color: "$gray-80",
  fontFamily: "$openSans",
});

interface ISelectAllCheckboxProps {
  checked: boolean;
  indeterminate: boolean;
  disabled: boolean;
  onChange: () => void;
  "aria-label"?: string;
}

/** A native checkbox whose "some selected" state is set the only way it can be: via the DOM. */
export function SelectAllCheckbox({
  checked,
  indeterminate,
  disabled,
  onChange,
  "aria-label": ariaLabel = "Select all patients on this page",
}: ISelectAllCheckboxProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <SelectCell
      ref={ref}
      type="checkbox"
      aria-label={ariaLabel}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
  );
}
